<template>
  <div v-if="isDisclaimer" class="l-wrapper">
    <UiDisclaimerListDisclaimer
      v-if="category.is_drug"
      text="Имеются противопоказания, необходима консультация специалиста"
    />
    <UiDisclaimerListDisclaimer
      v-if="category.is_dietary_supplement"
      text="Товары данной категории не являются лекарственным средством, требуется консультация специалиста"
    />
    <UiDisclaimerListDisclaimer
      v-if="category.is_baby_food"
      text="Ознакомьтесь с порядком употребления на упаковке. Необходима консультация специалиста. Молочные смеси не являются полноценными заменителями грудного молока."
    />
  </div>
</template>

<script lang="ts">
export default defineComponent({
  name: 'DisclaimerList',
  props: {
    category: {
      type: Object as () => {
        is_drug: boolean;
        is_dietary_supplement: boolean;
        is_baby_food: boolean;
      },
      required: true,
    },
  },
  setup(props: any) {
    const isDisclaimer = computed<boolean>(
      () =>
        props.category?.is_drug ||
        props.category?.is_dietary_supplement ||
        props.category?.is_baby_food
    );

    return { isDisclaimer };
  },
});
</script>

<style lang="scss" scoped>
.l-wrapper {
  margin-bottom: 12px;
}
</style>
